/* eslint-disable */
// Define assets path "On The Fly"
__webpack_public_path__ = window.euPortalConfig.assetPath;
/*eslint-enable */

// import validationHandler from '../modules/validation-signup-handler';
import inboxSocialIntegration from '../modules/inbox-social-integration';
import { fillReferrer } from '../modules/referrer-handler'

const initialize = () => {
    fillReferrer();
    const inboxSocial = new inboxSocialIntegration(null);
    inboxSocial.registerRedirectQueryDataHandler();
    import(/* webpackChunkName: "validation-signup-handler" */ '../modules/validation-signup-handler').then(module => {
        const validationHandler = module.default;
        validationHandler('personal');
    });
    //validationHandler('personal');
};

export default initialize;
